import SmartSuggestionsPlugin from './plugin/SmartSuggestionsPlugin';
import smartSuggestionsPluginTrigger from './utils/smartSuggestionsPluginTrigger';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SmartSuggestions" */ './plugin/SmartSuggestionsPlugin')
);

export type LazySmartSuggestionsPlugin = LazyPlugin<SmartSuggestionsPlugin>;

export let LazySmartSuggestionsPluginClass = createLazyPlugin(
    lazyModule,
    m => m.default,
    'SmartSuggestion',
    smartSuggestionsPluginTrigger
);
